const e = {
  element: "svg",
  "data-testid": "icon",
  "data-name": "FarCalendarCheck",
  viewBox: "0 0 448 512",
  xmlns: "http://www.w3.org/2000/svg",
  children: [
    {
      element: "path",
      d: "M128 0c13.3 0 24 10.7 24 24v40h144V24c0-13.3 10.7-24 24-24s24 10.7 24 24v40h40c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128c0-35.3 28.7-64 64-64h40V24c0-13.3 10.7-24 24-24zm272 192H48v256c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V192zm-71 105L217 409c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47 95-95c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
    }
  ]
}, a = {
  element: "svg",
  "data-testid": "icon",
  "data-name": "FarCheck",
  viewBox: "0 0 448 512",
  xmlns: "http://www.w3.org/2000/svg",
  children: [
    {
      element: "path",
      d: "M441 103c9.4 9.4 9.4 24.6 0 33.9L177 401c-9.4 9.4-24.6 9.4-33.9 0L7 265c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l119 119L407 103c9.4-9.4 24.6-9.4 33.9 0z"
    }
  ]
}, t = {
  element: "svg",
  "data-testid": "icon",
  "data-name": "FarChevronLeft",
  viewBox: "0 0 320 512",
  xmlns: "http://www.w3.org/2000/svg",
  children: [
    {
      element: "path",
      d: "M15 239c-9.4 9.4-9.4 24.6 0 33.9L207 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L65.9 256 241 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L15 239z"
    }
  ]
}, c = {
  element: "svg",
  "data-testid": "icon",
  "data-name": "FarChevronRight",
  viewBox: "0 0 320 512",
  xmlns: "http://www.w3.org/2000/svg",
  children: [
    {
      element: "path",
      d: "M305 239c9.4 9.4 9.4 24.6 0 33.9L113 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L79 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L305 239z"
    }
  ]
}, s = {
  element: "svg",
  "data-testid": "icon",
  "data-name": "FarCircle",
  viewBox: "0 0 512 512",
  xmlns: "http://www.w3.org/2000/svg",
  children: [
    {
      element: "path",
      d: "M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0z"
    }
  ]
}, n = {
  element: "svg",
  "data-testid": "icon",
  "data-name": "FarCopy",
  viewBox: "0 0 448 512",
  xmlns: "http://www.w3.org/2000/svg",
  children: [
    {
      element: "path",
      d: "M384 336H192c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h140.1l67.9 67.9V320c0 8.8-7.2 16-16 16zm-192 48h192c35.3 0 64-28.7 64-64V115.9c0-12.7-5.1-24.9-14.1-33.9l-67.8-67.9c-9-9-21.2-14.1-33.9-14.1H192c-35.3 0-64 28.7-64 64v256c0 35.3 28.7 64 64 64zM64 128c-35.3 0-64 28.7-64 64v256c0 35.3 28.7 64 64 64h192c35.3 0 64-28.7 64-64v-32h-48v32c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V192c0-8.8 7.2-16 16-16h32v-48H64z"
    }
  ]
}, l = {
  element: "svg",
  "data-testid": "icon",
  "data-name": "FarSquare",
  viewBox: "0 0 448 512",
  xmlns: "http://www.w3.org/2000/svg",
  children: [
    {
      element: "path",
      d: "M384 80c8.8 0 16 7.2 16 16v320c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16h320zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"
    }
  ]
}, r = {
  element: "svg",
  "data-testid": "icon",
  "data-name": "FarStarSharpHalfStroke",
  viewBox: "0 0 576 512",
  xmlns: "http://www.w3.org/2000/svg",
  children: [
    {
      element: "path",
      d: "M310.9 16.7C307.7 6.8 298.5 0 288 0s-19.7 6.8-22.9 16.7L214.5 176H56c-10.3 0-19.4 6.5-22.7 16.2s-.1 20.4 8 26.7l130.8 101.8-51 160c-3.2 10 .5 21 9.1 27s20.2 5.7 28.5-.7L288 406.4l129.3 100.5c8.3 6.5 19.8 6.8 28.5.7s12.3-16.9 9.1-27l-51-159.9 130.8-101.8c8.1-6.3 11.3-17 8-26.7S530.3 176 520 176H361.6L310.9 16.7zM288 103.2l33.1 104.1c3.2 10 12.4 16.7 22.9 16.7h106.1l-88.8 69.1c-7.9 6.2-11.2 16.6-8.1 26.2l32.5 102.3-82.9-64.5c-4.3-3.4-9.5-5.1-14.7-5.1V103.2z"
    }
  ]
}, h = {
  element: "svg",
  "data-testid": "icon",
  "data-name": "FarStarSharp",
  viewBox: "0 0 576 512",
  xmlns: "http://www.w3.org/2000/svg",
  children: [
    {
      element: "path",
      d: "M288 0c10.5 0 19.7 6.8 22.9 16.7L361.5 176H520c10.3 0 19.4 6.5 22.7 16.2s.1 20.4-8 26.7L403.9 320.7l50.9 160.1c3.2 10-.5 21-9.1 27s-20.2 5.7-28.5-.7L288 406.4 158.7 506.9c-8.3 6.5-19.8 6.8-28.5.7s-12.3-16.9-9.1-27L172 320.5 41.3 218.9c-8.1-6.3-11.3-17-8-26.7S45.7 176 56 176h158.5l50.6-159.3C268.3 6.8 277.5 0 288 0zm0 103.2-33.1 104.1c-3.2 10-12.4 16.7-22.9 16.7H125.9l88.8 69.1c7.9 6.2 11.2 16.6 8.1 26.2l-32.5 102.3 82.9-64.5c8.7-6.7 20.8-6.7 29.5 0l82.9 64.5-32.5-102.3c-3-9.6.2-20 8.1-26.2l88.9-69.1H344c-10.5 0-19.7-6.8-22.9-16.7L288 103.2z"
    }
  ]
}, d = {
  element: "svg",
  "data-testid": "icon",
  "data-name": "FarXmark",
  viewBox: "0 0 384 512",
  xmlns: "http://www.w3.org/2000/svg",
  children: [
    {
      element: "path",
      d: "M345 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-119 119L73 103c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l119 119L39 375c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l119-119L311 409c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-119-119L345 137z"
    }
  ]
};
export {
  r as F,
  h as a,
  d as b,
  e as c,
  t as d,
  c as e,
  n as f,
  a as g,
  l as h,
  s as i
};
